import { Component, Input, SimpleChanges } from '@angular/core';
import { trackReports } from '../../../../core/constants/constants';
import { TrackMXVarVarianceResponse } from '../../../../core/interface/mx-reports';
import { VarianceReportData } from '../../../../core/interface/export-reports';

@Component({
  standalone: false,
  selector: 'app-track-mx-var-variance',
  templateUrl: './track-mx-var-variance.component.html',
  styleUrl: './track-mx-var-variance.component.less',
})
export class TrackMxVarVarianceComponent {
  trackReport = trackReports;
  @Input()
  trackMXVarVarianceResponse!: TrackMXVarVarianceResponse[];
  @Input()
  reportData!: VarianceReportData;
  totalTrackSum: number = 0;
  totalMaxSum: number = 0;
  totalVarSum: number = 0;
  totalTrackCost: number = 0;
  totalMaxCost: number = 0;
  totalVarCost: number = 0;
  companyName: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trackMXVarVarianceResponse'].currentValue != null) {
      this.calculateSum();
      this.companyName = this.trackMXVarVarianceResponse[0].companyName;
    }
  }

  calculateSum() {
    this.totalTrackSum = 0;
    this.totalMaxSum = 0;
    this.totalVarSum = 0;
    this.totalTrackCost = 0;
    this.totalMaxCost = 0;
    this.totalVarCost = 0;
    this.trackMXVarVarianceResponse.forEach((response) => {
      this.totalTrackSum += response.sumTrackHrs;
      this.totalTrackCost += response.sumTrackCost;
      this.totalMaxSum += response.sumMaxHrs;
      this.totalMaxCost += response.sumMaxCost;
      this.totalVarSum += response.sumVarHrs;
      this.totalVarCost += response.sumVarCost;
    });
  }
}
